import { Injectable } from '@angular/core';
import { HttpEvent, HttpInterceptor, HttpHandler, HttpRequest, HttpResponse, HttpErrorResponse } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { tap, catchError } from 'rxjs/operators';
import { environment } from 'src/environments/environment';
import { AuthService, NotificationService, LanguageService, PermissionService } from '../services';
import { AuthToken, MessageError } from '../models';

@Injectable()
export class ApiInterceptor implements HttpInterceptor {

    queryFiles = [
        'uploadFile',
        'createFile',
        'updateFile',
        'importFile',
        'uploadPriceListFile',
        'readFile'
    ]

    constructor(
        private authService: AuthService,
        private languageService: LanguageService,
        private notification: NotificationService,
        private permissionService: PermissionService,
    ){}
    

    //
    intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        
        const authToken: AuthToken = this.authService.getToken();
        const language: string = this.languageService.getLanguage();
        
        if(this.checkUrl(request)){

            if(authToken && authToken.refresh_token && request.url == environment.apiUrls.npc.auth + '/refresh'){

                request = request.clone({
                    setHeaders: {
                        'Authorization': authToken.token_type + ' ' + authToken.refresh_token
                    }
                });
            }
            
            if(authToken && authToken.access_token && request.url != environment.apiUrls.npc.auth + '/refresh'){

                request = request.clone({
                    setHeaders: {
                        'Authorization': authToken.token_type + ' ' + authToken.access_token
                    }
                });
            }

            if(!this.checkFilesQuery(request)){

                request = request.clone({
                    setHeaders: {
                        'Content-Type': 'application/json'
                    }
                });
            }

            if(this.permissionService.currentModule){

                //check if not action - return
                
                request = request.clone({
                    setHeaders: {
                        'Module': this.permissionService.currentModule
                    }
                });
            }

            request = request.clone({
                setHeaders: {
                    'Language': language
                }
            });
            
            return next.handle(request).pipe(
                tap((event: HttpEvent<any>) => {

                        if (event instanceof HttpResponse) {

                            let res: any = this.res(event);

                            if(res.body != null){

                                if(!this.backendErrorHandling(res)){

                                    return res.body = null;
                                }
                            }
                            
                            return res.body;
                        }
                        
                        return;
                    }
                ),
                catchError((error: HttpErrorResponse) => {

                    let errorMessage: MessageError;
                    let callbackFunc: () => void;

                    console.log(error);

                    // if(error.error != null && error.error.hasOwnProperty('status')){

                    //     errorMessage = { 
                    //         code: error.error.status, 
                    //         message: error.error.message, 
                    //         details: error.error.result 
                    //     }
                    // }
                    // else{

                        errorMessage = { 
                            code: error.status, 
                            message: error.statusText, 
                            details: null 
                        }
                    // }
                    
                    switch (error.status) {
                        case 401:   // login
                            this.authService.deleteToken();
                            window.location.href = '/login';
                            break;
                        case 403:   // login
                        //     this.authService.deleteToken();
                        //     window.location.href = '/login';
                        //     break;
                            this.authService.setErrorMessage('Не правильный логин или пароль. Проверьте, пожалуйста, правильность введенных данных и повторите попытку.');
                            break;
                        default:    // other
                            this.showNotification(errorMessage, callbackFunc);
                            break;
                    }
                    
                    return throwError(errorMessage);
                })
            );
        }
        
        return next.handle(request);
    }


    /**
     * 
     * @param event 
     */
    res(event: HttpEvent<any>): HttpResponse<any>{

        var res: any[] = [];
        res.push(...[event]);

        return res[0];
    }  


    // ! ОБЪЕДИНИТЬ showNotification И backendErrorHandling


    /**
     * 
     * @param data 
     * @param callback 
     */
    showNotification(data: MessageError, callback: () => void): void {

        if(typeof data.message === 'string'){

            this.notification.show('danger', data.message);
            //alert('Ошибка. ' + data.code + ' ' + data.message);
        }
        else if(typeof data.message === 'object'){

            let msg: string = '';

            for(let field in data.message){

                for(let item of data.message[field]){

                    this.notification.show('danger', item);
                    //alert('Ошибка. ' + data.code + ' ' + data.message);
                }
            }
        }
        // else if(data.message.isArray()){ }

        setTimeout(()=>{

            if(callback != undefined){ callback(); }

        }, 1500);
    }


    /**
     * 
     * @param res 
     * @returns boolean
     */
    backendErrorHandling(res: any): boolean {

        if(res.body.hasOwnProperty('status')){

            if(res.body.status == 0){

                this.notification.show('danger', res.body.message);
                //alert('Ошибка. ' + res.body.message);
                console.error('[ERROR]: ', res.body.message);
                
                return res.body = false;
            }
            if(res.body.status == 2){

                //this.notification.show('warning', res.body.message);
                //alert('Предупреждение ' + res.body.message);
                console.warn('[WARNING]: ', res.body.message);
                
                return res.body = false;
            }
        }

        return true;
    }


    /**
     * 
     * @param request 
     * @returns 
     */
    checkUrl(request: HttpRequest<any>): boolean {

        const url: string = this.getBasisUrl(request);
        const api = environment.apiUrls;

        for(let project in api){

            for(let type in api[project]){
                
                if(api[project][type] == url){

                    return true;
                }
            }
        }

        return false;
    }


    /**
     * 
     * @param request 
     * @returns 
     */
    getBasisUrl(request: HttpRequest<any>): string {

        const url: string[] = request.url.split('/');

        if(url.length < 4){

            return url.join('/');
        }

        if(url.length > 4){

            url.splice(4);
        }

        return url.join('/');
    }


    /**
     * 
     * @param request 
     * @returns 
     */
    checkFilesQuery(request: HttpRequest<any>): boolean {

        const url: string[] = request.url.split('/');

        if(url.length > 4){
            
           if(this.queryFiles.indexOf(url[4]) > -1){

            return true;
           }
        }

        return false;
    }
}
 